import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_barcode } from "../shared/data.service";

import { wsBarcodeManagementMTABarcodeStatusDataParmInfo } from "../shared/wsBarcodeManagementMTABarcodeStatusDataParmInfo";
import { wsBarcodeManagementMTABarcodeStatusDataInfo } from "../shared/wsBarcodeManagementMTABarcodeStatusDataInfo";
import { wsBarcodeManagementMTABarcodeStatusInfo } from "../shared/wsBarcodeManagementMTABarcodeStatusDataInfo";
import { wsBarcodeManagementCardStatusUpdateParm } from "../shared/wsBarcodeManagementCardStatusUpdateParm";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./statusmta.component.html",
	styleUrls: ["./statusmta.component.css"],
	providers: [ConfirmationService],
})
export class StatusMTAComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_barcode,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserPersonID: number;
	public IDCardID: number;
	public IDStatusID: number;
	public Barcode: string;
	public UID: string;

	public BarcodeManagementMTABarcodeStatusData: wsBarcodeManagementMTABarcodeStatusDataInfo;
	public lstBarcodeStatusItems: wsBarcodeManagementMTABarcodeStatusInfo[] = [];
	public SelectedBarcodeStatus: wsBarcodeManagementMTABarcodeStatusInfo;

	public PersonID: number = -1;
	public FullName: string = "";
	public StaffStudentID: string = "";

	public Comment: string = "";

	public ErrorMessage: string = "";

	public PublicTransitLabel: string = "MTA";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserPersonID = this.dialogConfig.data.UserPersonID;
		this.IDCardID = this.dialogConfig.data.IDCardID;
		this.IDStatusID = this.dialogConfig.data.IDStatusID;
		this.Barcode = this.dialogConfig.data.Barcode;
		this.UID = this.dialogConfig.data.UID;
		this.PublicTransitLabel = this.dialogConfig.data.PublicTransitLabel;

		let parms: wsBarcodeManagementMTABarcodeStatusDataParmInfo = {
			AdministratorPersonID: this.UserPersonID,
			IDCardID: this.IDCardID,
		};

		this.isBusy = true;
		this.dataService.BarcodeManagementMTAStatusDataGet(parms).subscribe((data) => this.BarcodeManagementMTAStatusDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	BarcodeManagementMTAStatusDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	BarcodeManagementMTAStatusDataGet_Complete(data: any) {
		this.BarcodeManagementMTABarcodeStatusData = data;

		this.PersonID = this.BarcodeManagementMTABarcodeStatusData.PersonID;
		this.FullName = this.BarcodeManagementMTABarcodeStatusData.FullName;
		this.StaffStudentID = this.BarcodeManagementMTABarcodeStatusData.StaffStudentID;

		this.lstBarcodeStatusItems = this.BarcodeManagementMTABarcodeStatusData.BarcodeStatusItems;

		//
		//	Default select
		//
		this.SelectedBarcodeStatus = this.lstBarcodeStatusItems[0];

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStatusChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStatusChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdate() {
		this.ErrorMessage = "";

		let parms: wsBarcodeManagementCardStatusUpdateParm = {
			IDCardID: this.IDCardID,
			IDStatusID: -1,
			MTACardStatusID: this.SelectedBarcodeStatus.MTACardStatusID,
			c_PersonID: this.UserPersonID,
			Comment: this.Comment,
		};

		this.isBusy = true;
		this.dataService.BarcodeManagementCardStatusUpdate(parms).subscribe((data) => this.BarcodeManagementCardStatusUpdate_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	BarcodeManagementCardStatusUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	BarcodeManagementCardStatusUpdate_Complete(data: any) {
		this.isBusy = false;

		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(1);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
